import {Injectable} from '@angular/core';
import {RequestHeader} from '../models/request-offer/request-header.model';
import {BusinessParamName} from '../models/request-offer/request-offer.enum';
import {InsuranceCompanyCode} from '../models/insurance-company-code.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Injectable({
  providedIn: 'root'
})
export class OcDamagesDataService {

  last2YearsOcDamages: string;
  last5YearsOcDamages: string;
  atLeastOneValidMTUOffer = false;

  get ocDamagesDefined(): boolean {
    return this.atLeastOneValidMTUOffer && isNotNullOrUndefined(this.last2YearsOcDamages) && isNotNullOrUndefined(this.last5YearsOcDamages);
  }

  constructor() { }

  processOfferHeader(offerHeader: RequestHeader): void {
    if (!this.atLeastOneValidMTUOffer) {
      const insuranceCompanyCode = offerHeader.processContext.businessParameters.find(param => param.parameterName === BusinessParamName.INSURANCE_COMPANY_CODE).parameterValue;
      if (insuranceCompanyCode === InsuranceCompanyCode.MTU || insuranceCompanyCode === InsuranceCompanyCode.ERGO_HESTIA) {
        this.atLeastOneValidMTUOffer = true;
        this.last2YearsOcDamages = this.getParamValue(offerHeader, BusinessParamName.LAST_2_YEARS_OC_DAMAGES);
        this.last5YearsOcDamages = this.getParamValue(offerHeader, BusinessParamName.LAST_5_YEARS_OC_DAMAGES);
      }
    }
  }

  resetData(): void {
    this.atLeastOneValidMTUOffer = false;
    this.last2YearsOcDamages = null;
    this.last5YearsOcDamages = null;
  }

  private getParamValue(header: RequestHeader, paramName: BusinessParamName): any {
    const param = header.processContext.businessParameters.find(parameter => parameter.parameterName === paramName);
    return param ? param.parameterValue : null;
  }
}
